import React from 'react';
import { motion } from 'framer-motion';
import type { Icon } from '@phosphor-icons/react';
interface FormSectionProps {
  index: number;
  icon: Icon;
  title: string;
  caption: string;
  children: React.ReactNode;
}
export function FormSection({
  index,
  title,
  caption,
  children
}: FormSectionProps) {
  return <motion.section initial={{
    opacity: 0,
    y: 12
  }} whileInView={{
    opacity: 1,
    y: 0
  }} viewport={{
    once: true,
    margin: '-100px'
  }} transition={{
    duration: 0.3,
    ease: [0.22, 1, 0.36, 1]
  }} className="mt-12 pt-2" data-id="element-61">
      <header className="mb-7" data-id="element-62">
        <div className="flex items-baseline justify-between gap-4 border-b-2 border-[hsl(var(--foreground))] pb-1.5" data-id="element-63">
          <h2 className="font-mono text-sm font-semibold uppercase tracking-[0.14em] text-[hsl(var(--foreground))]" data-id="element-64">
            Section {index} — {title}
          </h2>
          <span className="shrink-0 font-mono text-[10px] text-[hsl(var(--muted-foreground))]" data-id="element-65">
            CU-1040.{index}
          </span>
        </div>
        <p className="mt-2 text-xs italic text-[hsl(var(--muted-foreground))]" data-id="element-66">
          {caption}
        </p>
      </header>
      <div className="space-y-8" data-id="element-67">{children}</div>
    </motion.section>;
}